import { Image, Layout, Menu, Drawer, Button } from "antd";
import {
  AuditOutlined,
  CheckCircleOutlined,
  CheckOutlined,
  DollarOutlined,
  FileOutlined,
  FormOutlined,
  LogoutOutlined,
} from "@ant-design/icons";

import { putForm } from "./FormPart";
import { images_folder, doSignOut, getStoredItem } from "./client";
const { Sider } = Layout;
const icons = {
  form: <FormOutlined />,
  dollar: <DollarOutlined />,
  audit: <AuditOutlined />,
  doc: <FileOutlined />,
  review: <CheckCircleOutlined />,
  complete: <CheckOutlined />,
};

const StepNavigation = (props) => {
  const menu_items = [];
  const rootMenuKeys = [];

  for (let i = 0; i <= 4; i++) rootMenuKeys.push("sub" + i);
  const handleClick = (e) => {
    props.setActiveMenuItem(e.key);
    const form_id = e.key.split("sub_sub")[1];
    const data = {
      uid: getStoredItem("uid"),
      token: getStoredItem("token"),
      application_type: getStoredItem("applicationType"),
      form_id: form_id,
      form_data: "",
      going_back: 1,
    };
    putForm(data, props);
  };
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find(
      (key) => props.openMenu.indexOf(key) === -1
    );
    if (rootMenuKeys.indexOf(latestOpenKey) === -1) {
      props.setOpenMenu(keys);
    } else {
      props.setOpenMenu(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  function getItem(label, key, icon, type, disabled, children) {
    return {
      key,
      icon,
      label,
      type,
      disabled: disabled,
      children,
    };
  }
  props.menu.forEach((parts, i) => {
    const subMenuItems = [];
    parts.stages.forEach((stage, j) => {
      const key = "sub_sub" + (i + 1) + "_" + (j + 1);
      subMenuItems.push(getItem(stage.name, key, "", "", stage.disabled));
    });
    menu_items.push(
      getItem(
        parts.title,
        "sub" + i,
        icons[parts.icon],
        "",
        parts.disabled,
        subMenuItems
      )
    );
  });
  return (
    <>
      <Sider className="hide-x-mobile" collapsed={false} width="270">
        <div className="logo">
          <Image
            width={120}
            preview={false}
            src={images_folder(props.applicationHeader.logo)}
          />
          <h3 className="sub-heading">{props.applicationHeader.text}</h3>
        </div>
        <Menu
          theme="dark"
          openKeys={props.openMenu}
          onClick={handleClick}
          onOpenChange={onOpenChange}
          selectedKeys={props.activeMenuItem}
          mode="inline"
          items={menu_items}
        />
      </Sider>
      <Drawer
        className="mobile-menu"
        title=""
        placement="right"
        onClose={props.onMobileMenuClose}
        open={props.openMobileMenu}
      >
        <div style={{ color: "#fff", textAlign: "center" }}>
          <p>{props.welcomeMessage}</p>
          <Button onClick={doSignOut} size="medium" className="">
            <LogoutOutlined /> Sign Out
          </Button>
        </div>
        <hr />
        <br />
        <Menu
          theme="dark"
          openKeys={props.openMenu}
          onClick={handleClick}
          onOpenChange={onOpenChange}
          selectedKeys={props.activeMenuItem}
          mode="inline"
          items={menu_items}
        />
      </Drawer>
    </>
  );
};

export default StepNavigation;
